import WebServiceRequest from "../../../Api/WebServiceRequest";

class PhysicalCategoryDeleteRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setId(id) {
    super.setTag("PhysicalCategory/Delete?id=" + id);
  }
}
export default PhysicalCategoryDeleteRequest;
